// Component copy to pressable-wrapper.tsx on create-scheduled-tournament
import { Platform, Pressable, View } from 'react-native'

type PressableWrapperProps = {
  children: React.ReactNode
  onPress?: () => void
}

export const PressableWrapper = ({ children, onPress }: PressableWrapperProps) => {
  if (Platform.OS === 'web') {
    return <View style={{ flex: 1 }}>{children}</View>
  }

  return <Pressable onPress={onPress}>{children}</Pressable>
}
